import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=11ad9ae0&"
import script from "./CustomerRegister.vue?vue&type=script&lang=js&"
export * from "./CustomerRegister.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports